import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const EASE = [0.16, 1, 0.3, 1];

// Small uppercase editorial eyebrow
export const Eyebrow = ({ children, light = false, className = "" }) => (
  <span
    className={`inline-block font-sans text-xs md:text-sm uppercase tracking-[0.25em] font-medium ${
      light ? "text-gold" : "text-gold"
    } ${className}`}
    data-testid="eyebrow"
  >
    {children}
  </span>
);

// Primary CTA button (link)
export const PrimaryButton = ({ to = "/contact", children = "Book a Strategy Call", testId = "book-a-call-btn", light = false }) => (
  <Link
    to={to}
    data-testid={testId}
    className={`group inline-flex items-center gap-3 px-8 py-4 rounded-sm font-sans text-sm tracking-wide transition-colors duration-300 ease-out ${
      light
        ? "bg-ivory text-charcoal hover:bg-gold hover:text-ivory"
        : "bg-charcoal text-ivory hover:bg-gold"
    }`}
  >
    <span>{children}</span>
    <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" strokeWidth={1.5} />
  </Link>
);

// Secondary text link with animated gold underline
export const SecondaryLink = ({ to, children, testId, light = false }) => (
  <Link
    to={to}
    data-testid={testId}
    className={`group relative inline-flex items-center gap-2 font-sans text-sm tracking-[0.15em] uppercase ${
      light ? "text-ivory" : "text-charcoal"
    }`}
  >
    <span className="relative">
      {children}
      <span className="absolute -bottom-1 left-0 w-0 h-px bg-gold transition-all duration-300 ease-out group-hover:w-full" />
    </span>
    <span className="transition-transform duration-300 group-hover:translate-x-1">→</span>
  </Link>
);

// Fade-up on scroll
export const Reveal = ({ children, delay = 0, className = "", y = 40 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, ease: EASE, delay }}
  >
    {children}
  </motion.div>
);

// Masked line-by-line reveal (for hero headlines). `lines` = array of strings.
export const LineReveal = ({ lines, className = "", delay = 0 }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="line-mask">
        <motion.span
          className="block"
          initial={{ y: "110%" }}
          animate={{ y: 0 }}
          transition={{ duration: 1, ease: EASE, delay: delay + i * 0.12 }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

export { EASE };
